import {
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useEffect, useState } from 'react';
import { dateDisplay } from '../Helpers/dateDisplay';
import { getPeopleInSession } from '../Helpers/getPeopleInSession';
import { isSessionToday } from '../Helpers/isSessionToday';
import { Person } from '../Models/person';
import { SessionWithId } from '../Models/session';

interface SessionDialogProps {
    open: boolean;
    login: boolean;
    close: () => void;
    action: (session: SessionWithId) => void;
    session: SessionWithId;
}

export const SessionDialog: React.FC<SessionDialogProps> = ({
    open,
    login,
    action,
    close,
    session,
}) => {
    const [people, setPeople] = useState<Person[]>([]);

    useEffect(() => {
        if (open) {
            getPeopleInSession(session.session).then((res) => {
                setPeople(res);
            });
        }
    }, [open, session]);

    const isToday = isSessionToday(session);

    const onConfirmHandler = () => {
        action(session!);
        close();
    };

    const onCloseHandler = () => {
        close();
    };

    const peopleComponents = people.map((person, id) => {
        return (
            <div key={id}>
                {person.firstName} {person.lastName[0]}
            </div>
        );
    });

    return (
        <Dialog open={open} onClose={close} fullWidth={true}>
            <DialogTitle>
                {login ? 'Přihlášení na lekci' : 'Odhlášení z lekce'}
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <DialogContentText>
                        <Typography variant="h6">Datum a čas</Typography>
                        <Typography variant="body1">
                            {dateDisplay(session.session)}
                        </Typography>
                    </DialogContentText>
                    <DialogContentText>
                        <Typography component="div" variant="h6">
                            Lidé
                        </Typography>
                        <Typography component="div" variant="body1">
                            {people.length === 0
                                ? 'Zatím nikdo není přihlášen'
                                : peopleComponents}
                        </Typography>
                    </DialogContentText>
                    {session.session.description !== '' && (
                        <DialogContentText>
                            <Typography component="div" variant="h6">
                                Popis
                            </Typography>
                            <Typography component="div" variant="body1">
                                {session.session.description}
                            </Typography>
                        </DialogContentText>
                    )}
                    <DialogContentText>
                        <Typography component="div" variant="h6">
                            Obtížnost
                        </Typography>
                        <Typography component="div" variant="body1">
                            {session.session.difficulty}
                        </Typography>
                    </DialogContentText>
                    <DialogContentText>
                        <Typography component="div" variant="h6">
                            Adresa
                        </Typography>
                        <Typography component="div" variant="body1">
                            {session.session.location}
                        </Typography>
                    </DialogContentText>
                </Stack>
            </DialogContent>
            <DialogActions>
                {!login && isToday && (
                    <Typography
                        color="error"
                        variant="body1"
                        sx={{ marginRight: '20px' }}
                    >
                        Nelze odhlásit dnešní lekci
                    </Typography>
                )}
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onCloseHandler}
                >
                    Zrušit
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    disabled={!login && isToday}
                    onClick={onConfirmHandler}
                >
                    {login ? 'Přihlásit' : 'Odhlásit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
